import { styled } from '@vw-marketing/us-components';

export const StyledImageDisclaimerWrapper = styled.div``;
